"use client"

import { useLanguage } from "@/lib/language-context"
import { SignOutButton } from "@/components/auth/sign-out-button"

interface AccountHeaderProps {
    user: any
}

export function AccountHeader({ user }: AccountHeaderProps) {
    const { t } = useLanguage()
    const userName = user?.user_metadata?.full_name?.split(' ')[0] || user?.email?.split('@')[0]

    return (
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 mb-12 animate-in fade-in slide-in-from-top-4 duration-700 w-full min-w-0">
            <div className="flex-1 min-w-0 w-full">
                <div className="flex items-center gap-2 mb-3">
                    <span className="h-1.5 w-8 bg-primary rounded-full flex-shrink-0"></span>
                    <span className="text-[10px] sm:text-xs font-black uppercase tracking-normal sm:tracking-widest text-primary/70 truncate">{t("account.dashboard")}</span>
                </div>
                <h1 className="text-3xl sm:text-7xl font-black text-gray-900 tracking-tight sm:tracking-tighter leading-snug sm:leading-[0.9] mb-4 break-words hyphens-auto max-w-full">
                    {t("account.hello")}, <span className="bg-gradient-to-r from-primary to-teal-600 bg-clip-text text-transparent">{userName}!</span>
                </h1>
                <p className="text-sm sm:text-lg font-medium text-gray-500 max-w-lg leading-relaxed">
                    {t("account.manage_desc")}
                </p>
            </div>
            <div className="flex items-center pt-2 sm:pt-0 flex-shrink-0">
                <SignOutButton />
            </div>
        </div>
    )
}
